import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { clientsService } from '../services/api';
import { ClientModal } from '../components/ClientModal';
import { formatApptDateLong, formatApptTime } from '../utils/dateFormatters';
import './ClientDetail.css';

export default function ClientDetail() {
  const { id } = useParams();
  const [client, setClient] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState(false);

  async function load() {
    setLoading(true);
    const [c, a] = await Promise.all([clientsService.getById(id), clientsService.getAppointments(id)]);
    if (c.success) setClient(c.customer);
    if (a.success) setAppointments(a.appointments || []);
    setLoading(false);
  }
  useEffect(() => { load(); }, [id]);

  if (loading) return <div className="empty-state"><div className="loading-spinner"></div></div>;
  if (!client) return <div className="empty-state"><p>Client not found</p><Link to="/clients" className="btn btn-outline">Back to clients</Link></div>;

  const addr = [client.address_street, client.address_suburb, client.address_state, client.address_postcode].filter(Boolean).join(', ');

  return (
    <div className="client-detail">
      <div className="page-header">
        <div>
          <Link to="/clients" className="back-link">← Clients</Link>
          <h1 className="page-title">{client.name}</h1>
        </div>
        <button className="btn btn-outline" onClick={() => setEditing(true)}>Edit</button>
      </div>

      <div className="client-detail-grid">
        <section className="card">
          <h2 className="card-title mb-md">Contact</h2>
          {client.phone && <p><a className="click-to-call" href={`tel:${client.phone}`}>{client.phone}</a></p>}
          {client.email && <p><a className="click-to-call" href={`mailto:${client.email}`}>{client.email}</a></p>}
          {addr && <p className="text-muted mt-sm">{addr}</p>}
          {client.notes && <p className="mt-md">{client.notes}</p>}
        </section>

        <section className="card">
          <h2 className="card-title mb-md">Appointments ({appointments.length})</h2>
          {appointments.length === 0 ? <p className="text-muted">No appointments yet.</p> : (
            <div className="client-appt-list">
              {appointments.map((a) => (
                <div key={a.id} className="client-appt">
                  <div className="client-appt-when">
                    <strong>{formatApptDateLong(a.starts_at)}</strong>
                    <span className="text-muted">{formatApptTime(a.starts_at)}</span>
                  </div>
                  <span>{a.service_name} · {a.staff_name}</span>
                  <span className={`status-badge status-${a.status.replace('_', '-')}`}>{a.status.replace('_', ' ')}</span>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>

      <ClientModal isOpen={editing} onClose={() => setEditing(false)} onSave={() => { setEditing(false); load(); }} client={client} />
    </div>
  );
}
